import { DefaultTheme } from 'styled-components'

export const lightTheme: DefaultTheme = {
  bgColor: '#f5f6fa',
  textColor: '#2f3640',
  accentColor: '#2f3640',
}
export const darkTheme: DefaultTheme = {
  bgColor: '#353b48',
  textColor: '#e1b12c',
  accentColor: '#e84118',
}
